import React, { useEffect, useState } from 'react';
import './FreebiePage.scss';
import { Helmet } from 'react-helmet-async';
import { baseStrapiURL, baseURL } from '../../services/config';
import { useCollectionQuery } from '../../services/strapi/hooks';
import Loading from '../../components/Loading/Loading';
import { useQueryClient } from '@tanstack/react-query';
import Error404Page from '../Error404Page/Error404Page';
import StrapiImageWithSkeleton from '../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import FreebieForm from './components/FreebieForm/FreebieForm';
import { useMediaQuery } from 'react-responsive';
import { safeHtml } from '../../services/helpers';
import { useLocation } from 'react-router-dom';

const FreebiePage = ({setNotification, setFreebieModalContent, setShowFreebieModal}) => {

    const isTab = useMediaQuery({ maxWidth: 1023 }); // Breakpoint pour LG
    const location = useLocation();
    const [slug, setSlug] = useState('');
    const collectionType = 'freebie';
    
    const strapiPage = 'freebie';

    const queryClient = useQueryClient();

    useEffect(() => {
        setSlug(location.pathname.slice(10));
    }, [location])

    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useCollectionQuery(
        strapiPage,
        slug,
        false,
        true
    );


    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-content', strapiPage]);

    // N'afficher le chargement que si les données ne sont pas disponibles
    const showLoading = isLoading && !displayData;

    useEffect(() => {
        window.scroll(0, 0);
        if (displayData) {
            setFreebieModalContent({
                Remerciements: displayData.Remerciements,
            })
        }
    }, [displayData]);

    if (showLoading) return <Loading />;
    if (!displayData || displayData.length === 0 || error) return <Error404Page />;

    return (
        <div className="freebie-page">
            <Helmet>
                {/* Open Graph (utilisé par Facebook, LinkedIn, etc.) */}
                <meta property="og:title" content={displayData.SEO.TitreOnglet} />
                <meta property="og:description" content={displayData.SEO.Description} />
                <meta property="og:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta property="og:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={displayData.SEO.TitreOnglet} />
                <meta name="twitter:description" content={displayData.SEO.Description} />
                <meta name="twitter:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta name="twitter:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />

                <title>{displayData.SEO.TitreOnglet}</title>
                <meta name="description" content={displayData.SEO.Description} />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/freebie/background.jpg"
                    fetchPriority="high"
                />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/freebie/background.webp"
                    fetchPriority="high"
                />
            </Helmet>
            <div className="picture-container">
                <StrapiImageWithSkeleton
                    picture={strapiData.EnTete.Photo}
                    loading="lazy"
                />
                <div className="freebie-page__content">
                    {
                        isTab ?
                            <div className="freebie-page__text" dangerouslySetInnerHTML={safeHtml(strapiData.EnTete.TexteMobile)} />

                            :
                            <div className="freebie-page__text" dangerouslySetInnerHTML={safeHtml(strapiData.EnTete.Texte)} />
                    }

                    <FreebieForm
                        setNotification={setNotification}
                        setShowFreebieModal={setShowFreebieModal}
                        BoutonFormulaire={strapiData.EnTete.BoutonFormulaire}
                        slug={slug}
                    />
                </div>
            </div>
        </div>
    );
};

export default FreebiePage;